import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from '../interfaces/state';
import { AUTH_FEATURE_KEY, AuthState } from '../interfaces/auth';

const state = createFeatureSelector<State, AuthState>(AUTH_FEATURE_KEY);
export const selectToken = createSelector(state, ({ token }) => token);
export const selectRemember = createSelector(state, ({ remember }) => remember);